var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhats(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.927,
    height: 30,
    viewBox: "0 0 29.927 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23",
    "data-name": "Grupo 23",
    transform: "translate(-297.259 -369.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_46",
    "data-name": "Trazado 46",
    d: "M297.259,399.07l2.151-8.025a14.849,14.849,0,1,1,5.915,5.864Zm8.467-5.168.508.3a12.057,12.057,0,1,0-4.124-4.087l.311.511-1.2,4.48Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_47",
    "data-name": "Trazado 47",
    d: "M319.306,387.391a2.5,2.5,0,0,0-2.122-.478c-.551.226-.9,1.089-1.26,1.53a.528.528,0,0,1-.683.148,9.616,9.616,0,0,1-4.8-4.108.589.589,0,0,1,.075-.8,3.235,3.235,0,0,0,.871-1.414,3.1,3.1,0,0,0-.389-1.675,3.971,3.971,0,0,0-1.236-1.863,1.694,1.694,0,0,0-1.839.273,3.736,3.736,0,0,0-1.295,2.959,4.208,4.208,0,0,0,.116.939,7.8,7.8,0,0,0,.9,2.076,16.6,16.6,0,0,0,.94,1.43,14.507,14.507,0,0,0,4.078,3.786,12.331,12.331,0,0,0,2.543,1.21,5.652,5.652,0,0,0,2.96.467,3.586,3.586,0,0,0,2.684-2,1.731,1.731,0,0,0,.124-1.019C320.824,388.148,319.874,387.731,319.306,387.391Z",
    transform: "translate(-1.425 -1.443)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhats);
export default __webpack_public_path__ + "static/media/whats.43b585c3549f8baf25320cd653b28c5f.svg";
export { ForwardRef as ReactComponent };